import {Link} from 'react-router-dom'
import EntityPerformanceChartModal from '../../../../components/EntityPerformanceChartModal/EntityPerformanceChartModal'
import {useContext, useState} from 'react'
import {CustomerReportContext} from '../../context'
import { MIN_DATE_RANGE } from '../../utils'

const CustomerTypeReportRow = ({row}: any) => {
  const [showChartModal, setShowChartModal] = useState(false)
  const {
    onCustomerTypeEntityPerformanceChartIdChange,
    onCustomerTypeEntityPerformanceChartViewChange,
    onCustomerTypeEntityPerformanceChartDateRangeChange,
    customerTypeEntityPerformanceChartFilters,
    isCustomerTypeEntityPerformanceChartDataLoading,
    customerTypeEntityPerformanceChartData,
  } = useContext(CustomerReportContext)
  
  return (
    <>
      <tr>
        <td>{row.customerType}</td>
        <td>
          <Link
            to={{
              pathname: '/analytics/profitability/profitability-report',
              search: `?view=order-report&report_type=coupon_discount&customer_type=${row.customerType}`,
            }}
            target='_blank'
            className='text-dark text-decoration-underline'
          >
            {row.order}
          </Link>
        </td>
        <td>
          <Link
            to={{
              pathname: '/analytics/profitability/profitability-report',
              search: `?view=order-report&report_type=coupon_discount&customer_type=${row.customerType}&coupon_code_type=freeship`,
            }}
            target='_blank'
            className='text-dark text-decoration-underline'
          >
            {row.freeship}
          </Link>
        </td>
        <td>
          <Link
            to={{
              pathname: '/analytics/profitability/profitability-report',
              search: `?view=order-report&report_type=coupon_discount&customer_type=${row.customerType}&coupon_code_type=sf`,
            }}
            target='_blank'
            className='text-dark text-decoration-underline'
          >
            {row.sf_coupon}
          </Link>
        </td>
        <td>
          <Link
            to={{
              pathname: '/analytics/profitability/profitability-report',
              search: `?view=order-report&report_type=coupon_discount&customer_type=${row.customerType}&coupon_code_type=sll`,
            }}
            target='_blank'
            className='text-dark text-decoration-underline'
          >
            {row.sll}
          </Link>
        </td>
        <td>
          <Link
            to={{
              pathname: '/analytics/profitability/profitability-report',
              search: `?view=order-report&report_type=coupon_discount&customer_type=${row.customerType}&coupon_code_type=5offoneorder`,
            }}
            target='_blank'
            className='text-dark text-decoration-underline'
          >
            {row.five_percent_off}
          </Link>
        </td>
        <td>
          <Link
            to={{
              pathname: '/analytics/profitability/profitability-report',
              search: `?view=order-report&report_type=coupon_discount&customer_type=${row.customerType}&coupon_code_type=other`,
            }}
            target='_blank'
            className='text-dark text-decoration-underline'
          >
            {row.other_coupon}
          </Link>
        </td>
        <td>{row.couponCodeValue}</td>
        <td>{row.contributedCouponPercentage}</td>
        <td>
          <div className='d-flex justify-content-end'>
            <span
              onClick={() => setShowChartModal(true)}
              className='w-30px h-30px d-flex justify-content-center align-items-center text-primary cursor-pointer'
            >
              <i className='fas fa-chart-line text-primary'></i>
            </span>
          </div>
        </td>
      </tr>
      {showChartModal && (
        <EntityPerformanceChartModal
          onClose={() => setShowChartModal(false)}
          entityId={row.customerType}
          entityName={`Coupon Code Report - ${row.customerType}`}
          onEntityPerformanceChartIdChange={onCustomerTypeEntityPerformanceChartIdChange}
          onEntityPerformanceChartViewChange={onCustomerTypeEntityPerformanceChartViewChange}
          onEntityPerformanceChartDateRangeChange={
            onCustomerTypeEntityPerformanceChartDateRangeChange
          }
          entityPerformanceChartFilters={customerTypeEntityPerformanceChartFilters}
          isEntityPerformanceChartDataLoading={isCustomerTypeEntityPerformanceChartDataLoading}
          entityPerformanceChartData={customerTypeEntityPerformanceChartData}
          startDate={MIN_DATE_RANGE}
        />
      )}
    </>
  )
}

export default CustomerTypeReportRow
